// HMR/WebSocket guard for production builds to suppress dev-server WS noise
// Silent mode: no console noise, no URL changes. Safe for production builds.
(function installHMRGuard(){
  try {
    if (typeof window === 'undefined') return;
    if (window.__HMR_GUARD_INSTALLED__) return;

    // Treat localhost only as dev; all other hosts = prod
    const isDev = (typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost');
    if (isDev) return; // allow WS in dev

    // Strict filter for dev-only transport paths
    const DEV_PATH_RE = /sockjs|hmr|hot|webpack|vite|wds|livereload|ws|eventsource|browser-sync|refresh|dev-server/i;

    const OriginalWS = window.WebSocket;
    const OriginalES = window.EventSource;

    // Silent console filter for known dev transport errors only
    const originalConsoleError = window.console && window.console.error ? window.console.error.bind(window.console) : null;
    if (originalConsoleError) {
      window.console.error = function(...args){
        try {
          const msg = (args && args.length ? String(args[0]) : '') || '';
          // Suppress ONLY dev transport noise
          if (/WebSocket connection to/.test(msg) && DEV_PATH_RE.test(msg)) return;
          if (/WebSocket connection to/.test(msg) && /:3000\/ws/.test(msg)) return; // React dev server WS
          if (/EventSource/.test(msg) && DEV_PATH_RE.test(msg)) return;
          if (/sockjs-client/i.test(msg)) return;
          if (/webpack/i.test(msg)) return;
          if (/vite/i.test(msg)) return;
          if (/posthog/i.test(msg)) return; // analytics noise
        } catch(_) {}
        return originalConsoleError ? originalConsoleError(...args) : undefined;
      };
    }

    const isDevWebSocketUrl = (url) => {
      try {
        const u = new URL(url, window.location.href);
        const sameHost = u.hostname === window.location.hostname;
        const hasExplicitPort = !!u.port;
        const portMismatch = hasExplicitPort && (u.port !== window.location.port);
        const devPathHint = DEV_PATH_RE.test(u.pathname);
        // Also treat port 3000 WebSocket as dev (React dev server)
        const isPort3000Ws = u.port === '3000' && u.pathname === '/ws';
        return (sameHost && portMismatch && devPathHint) || isPort3000Ws;
      } catch { return false; }
    };

    if (OriginalWS) {
      window.WebSocket = new Proxy(OriginalWS, {
        construct(target, args) {
          try {
            const [url] = args;
            if (isDevWebSocketUrl(url)) {
              // Return an inert socket-like object without logging
              const dummy = {
                readyState: 3,
                close: () => {},
                send: () => {},
                addEventListener: () => {},
                removeEventListener: () => {},
                onopen: null,
                onmessage: null,
                onerror: null,
                onclose: null
              };
              setTimeout(() => { if (typeof dummy.onclose === 'function') dummy.onclose({ code: 1006, reason: 'blocked' }); }, 0);
              return dummy;
            }
          } catch {}
          return new target(...args);
        }
      });
    }

    if (OriginalES) {
      window.EventSource = new Proxy(OriginalES, {
        construct(target, args) {
          try {
            const [url] = args;
            const u = new URL(url, window.location.href);
            const sameHost = u.hostname === window.location.hostname;
            const hasExplicitPort = !!u.port;
            const portMismatch = hasExplicitPort && (u.port !== window.location.port);
            const devPathHint = DEV_PATH_RE.test(u.pathname);
            if (sameHost && portMismatch && devPathHint) {
              // Inert EventSource-like object, no logs
              return { close: () => {} };
            }
          } catch {}
          return new target(...args);
        }
      });
    }

    window.__HMR_GUARD_INSTALLED__ = true;
  } catch (e) {
    // no-op
  }
})();